import React from 'react';
import { Link } from 'react-router-dom';
import { FaChalkboardTeacher, FaChess, FaHeart } from 'react-icons/fa';
import heroImage from '../assets/chess7.jpg';
import chess from '../assets/chess5.jpg';
import dance from '../assets/dance2.jpg';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="home-hero-section">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h1 className="home-hero-title display-4 font-weight-bold">Master Your Craft</h1>
              <p className="home-hero-subtitle lead">
                Expert 1-on-1 lessons in Chess and Dance, tailored to your unique potential.
              </p>
              <a href="#programs-section" className="btn btn-primary btn-lg mt-4">Explore Our Programs</a>
            </div>
          </div>
        </div>
        <div className="hero-image-container">
          <img src={heroImage} alt="Chess pieces" className="hero-image" />
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="why-choose-us-section text-center">
        <div className="container">
          <h2 className="section-title">Why Choose Polonsky Academy?</h2>
          <div className="row mt-5">
            <div className="col-md-4">
              <div className="feature-card">
                <FaChalkboardTeacher className="feature-icon" />
                <h3 className="feature-title">Expert Instructors</h3>
                <p>Learn from passionate and experienced teachers dedicated to your success.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-card">
                <FaChess className="feature-icon" />
                <h3 className="feature-title">Personalized Learning</h3>
                <p>Customized lesson plans tailored to your individual goals and learning style.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-card">
                <FaHeart className="feature-icon" />
                <h3 className="feature-title">Supportive Environment</h3>
                <p>A friendly and encouraging atmosphere to help you build confidence.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Programs Section */}
      <div id="programs-section" className="programs-section bg-light">
        <div className="container">
          <h2 className="section-title text-center">Our Programs</h2>
          <div className="row mt-5">
            <div className="col-md-6">
              <div className="program-card">
                <img src={chess} alt="Chess Program" className="program-card-img" />
                <div className="program-card-body">
                  <h3 className="program-card-title">Chess</h3>
                  <p className="program-card-text">Sharpen your mind and master the art of strategy with our expert chess coaches.</p>
                  <Link to="/chess" className="btn btn-primary">Explore Chess</Link>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="program-card">
                <img src={dance} alt="Dance Program" className="program-card-img" />
                <div className="program-card-body">
                  <h3 className="program-card-title">Dance</h3>
                  <p className="program-card-text">Express yourself and learn the art of movement with our passionate dance instructor.</p>
                  <Link to="/dance" className="btn btn-primary">Explore Dance</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* Cancellation Policy Section */}
      <div className="cancellation-section">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-body">
                  <h2 className="card-title text-center">Our Commitment & Cancellation Policy</h2>
                  <p className="card-text">At Polonsky Academy, we are committed to providing reliable and consistent instruction.</p>
                  <ul>
                    <li><strong>Our Guarantee:</strong> If an instructor must cancel or misses a scheduled lesson without providing at least 8 hours' notice, your next lesson with us is free.</li>
                    <li><strong>Student Cancellations:</strong> If a student cancels with less than 8 hours' notice or does not attend a scheduled lesson, the full lesson fee will be charged. We appreciate your understanding as this policy respects our instructors' time.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
